import classNames from 'classnames';
import React from 'react';
import styles from './Separator.module.scss';
function Separator({ size = '1', dropdown = false }) {
    const classes = classNames(styles.wrap, styles[`size-${size}`], { [styles.dropdown]: dropdown });
    return React.createElement("div", { className: classes });
}
export default Separator;
